















import { mapActions } from 'vuex';
import LoadingSpinner from '@reciprocity/loading-spinner';
import { getRequest } from '../../utils/client/client';

export default {
  name: 'DashboardListPage',
  components: {
    LoadingSpinner,
  },
  props: {
    benchmarkId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      benchmark: null,
    };
  },
  created() {
    this.setPageTitle({ title: 'Benchmark' });
    this.getBenchmark();
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
    }),
    getBenchmark() {
      getRequest({ url: '/dashboards/benchmarks' }).then(data => {
        this.benchmark = data.items.filter(i => i.id.toString() === this.benchmarkId)[0];
        this.loading = false;
      });
    },
  },
};
